<script setup lang="ts">
import type { SelectScrollUpButtonProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import { IconChevronUp } from '@tabler/icons-vue';
import { SelectScrollUpButton, useForwardProps } from 'reka-ui';
import { cn } from '@ui/lib/utils.js';

const props = defineProps<SelectScrollUpButtonProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
    <SelectScrollUpButton
        data-slot="select-scroll-up-button"
        v-bind="forwardedProps"
        :class="cn('flex cursor-default items-center justify-center py-1', props.class)"
    >
        <slot>
            <IconChevronUp class="size-4" />
        </slot>
    </SelectScrollUpButton>
</template>
